import { render, staticRenderFns } from "./BrandCheck.vue?vue&type=template&id=05432eaa&scoped=true&"
import script from "./BrandCheck.vue?vue&type=script&lang=js&"
export * from "./BrandCheck.vue?vue&type=script&lang=js&"
import style0 from "./BrandCheck.vue?vue&type=style&index=0&id=05432eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05432eaa",
  null
  
)

export default component.exports